<template>
  <e-dialog
    :dialog-title="dialogTitle"
    :center-dialog-visible="visible"
    :popup-width="dialogWidth"
    :show-btn="showBtn"
    :show-close-btn="showCloseBtn"
    :button-tip="confirmBtnText"
    @resetPopupData="handleCancel"
    @submitPopupData="handleConfirm"
  >
    <div style="min-height: 60px">
      <!-- 易权通申请开户-->
      <el-form
        v-if="[100, 102].includes(accountStatus)"
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="126px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="股份公司确认书："
          prop="legalPersonCertificate"
          :rules="rules.attachPath"
        >
          <div class="flex">
            <eui-upload
              ref="euiUpload"
              key-name="applicantCertificatePath"
              :file-list="fileList"
              :action="uploadPayCenterFile"
              :private-upload="privateUpload"
              :headers="headers"
              :show-file-list="true"
              accept=".jpg,.png"
              :limit="1"
              text="上传附件"
              @handleSuccess="uploadSuccess"
            >
            </eui-upload>
            <span>请上传清晰的扫描或复印件并加盖公司公章（红色）。</span>
          </div>
        </el-form-item>
        <el-form-item label="操作员：" label-width="126px">张三</el-form-item>
      </el-form>
      <!--查看进度-->
      <steps
        v-else-if="accountStatus === 101"
        :steps-list="stepsList"
        :show-submit-icon="true"
      ></steps>
      <!-- 注销专户-->
      <p v-else-if="accountStatus === 103">
        <template v-if="accountType === logoutCompanyAccount">
          注销支付账户会同时注销企业已开通的电商专户，易权通专
          户、产融还款专户。请确认是否注销支付账户！
        </template>
        <!--注销产融专户-->
        <template v-else>
          {{ tipsText }}
        </template>
      </p>
      <!-- 新增用户且操作模式为单人模式-->
      <p v-else-if="accountStatus === 99">
        当前支付账户为单人模式，请先修改已有操作用户权限为经办 或审核单一权限。
      </p>
      <!-- 查看快递单号-->
      <p v-else>
        {{ trackingNumber }}
      </p>
    </div>
  </e-dialog>
</template>

<script>
import Api from '@/modules/projectA/api/paymentAccount';
import EDialog from '../../../components/common/e-dialog.vue';
import {
  headers,
  privateUpload,
  uploadPayCenterFile,
  logoutCompanyAccount,
} from '../constant';
import Steps from '../components/steps';

export default {
  name: 'PlatformRules',
  components: { EDialog, Steps },
  mixins: [],
  props: {
    progressData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      dialogTitle: '',
      dialogWidth: '',
      showBtn: true,
      showCloseBtn: false,
      confirmBtnText: '',
      tipsText: '',
      fileList: [],
      uploadPayCenterFile,
      headers,
      privateUpload, // 私有仓库的地址
      reUploadFlag: false, // 是否重新上传
      ruleForm: {},
      rules: {},
      accountStatus: null, // 账户状态
      accountType: null,
      trackingNumber: '', // 快递单号
      stepsList: [
        {
          step: 1,
          desc: '提交审核',
          statusCode: '0,100',
          active: false,
          time: '',
        },
        {
          step: 2,
          desc: '待初审',
          statusCode: '101,102',
          active: false,
          time: '',
        },
        {
          step: 3,
          desc: '待复审',
          statusCode: '103,104,105',
          active: false,
          time: '',
        },
        {
          step: 4,
          desc: '开户成功',
          statusCode: '106',
          active: false,
          time: '',
        },
      ],
      reviewRefuseStatus: [102, 104], // 账户状态为初审拒绝、复审拒绝
      logoutCompanyAccount,
    };
  },
  watch: {
    progressData: {
      handler(newObj) {
        const step = this.stepsList.find(
          (item) => item?.statusCode.indexOf(newObj.accountSubApplyStatus) > -1
        )?.step;
        this.stepsList.forEach((item) => {
          if (item.step < step || item.step === step) {
            item.active = true;
          }
          if (item.step < step) {
            if (item.step === 1) {
              item.time = newObj?.applyTime;
            }
            if (item.step === 2) {
              item.desc = '初审通过';
              item.time = newObj?.trialTime;
            }
            if (item.step === 3) {
              item.desc = '待激活';
              item.time = newObj?.reviewTime;
            }
          }
          if (
            item.step === step &&
            this.reviewRefuseStatus.includes(this.accountStatus)
          ) {
            item.desc = '审核拒绝';
          }
        });
      },
      // 开启深度监听
      deep: true,
    },
  },
  created() {},

  methods: {
    initData(params) {
      this.accountStatus = params?.accountStatus;
      this.accountType = params?.accountType;
      this.dialogTitle = params.dialogTitle;
      this.dialogWidth = params.dialogWidth;
      this.showBtn = params.showBtn;
      this.showCloseBtn = params.showCloseBtn;
      this.confirmBtnText = params.confirmBtnText;
      this.trackingNumber = params?.trackingNumber;
      this.tipsText = params?.tipsText;
      // console.log(this.progressData, 'progressData');
      this.visible = true;
    },
    handleConfirm() {
      // 打开注销企业账户页面
      if (
        this.accountStatus === 103 &&
        this.accountType === logoutCompanyAccount
      ) {
        Api.checkCancelEpayAccount({
          accountType: this.accountType,
        }).then((res) => {
          if (res.code === '200') {
            if (res.data.status) {
              this.$router.push({
                name: 'PaymentAccountLogoutAccount',
                query: { accountType: this.accountType },
              });
            } else {
              this.$message.warning(
                '您还有未完成的支付业务，不能注销账户。请您确定所有在线支付业务完成后，再申请注销账户，谢谢！'
              );
            }
          }
        });
      }
      // 注销产融专户
      if (this.accountStatus === 103 && this.accountType === 2) {
        this.$router.push({
          name: 'PaymentAccountLogoutAccountSub',
          query: { accountType: this.accountType },
        });
      }
      // 修改用户
      if (this.accountStatus === 99) {
        this.$router.push({
          name: 'PaymentAccountUpdateUser',
          query: { changeMultipleMode: true, roleDisabled: false },
        });
      }
      // 易权通开户申请提交
      if (this.accountStatus === 100) {
      }
      this.handleCancel();
    },
    handleCancel() {
      this.visible = false;
    },
    // 易权通开户申请文件上传
    uploadSuccess() {
      this.reUploadFlag = true;
      // const tempObj = this.ruleForm.settleAccountAttachTempList.find(
      //   (attach) => attach.attachType === certificateType
      // );
      // if (tempObj) {
      //   this.$set(tempObj, 'attachName', attachObj[0]?.response?.data.fileName);
      //   this.$set(tempObj, 'attachPath', attachObj[0]?.response?.data.url);
      //   if (certificateType === 'AA' || certificateType === 'AC') {
      //     Api.addEpaySettleAccountApplicantAttach({
      //       attachName: attachObj[0]?.response?.data.fileName,
      //       attachPath: attachObj[0]?.response?.data.url,
      //       attachType: certificateType,
      //     });
      //   }
      // }
      // this.$nextTick(() => {
      //   this.$refs.ruleForm.clearValidate();
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  > span {
    color: #999;
    font-family: Source Han Sans CN;
    font-size: 12px;
    font-style: normal;
    font-weight: 350;
    //line-height: 12px; /* 100% */
    margin-left: 10px;
  }
  ::v-deep .eui-upload .file_text_item p {
    width: 90px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>
